module.exports = __webpack_public_path__ + "fronted/src/img/voice2.37cd4d4b.png";